import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-checkout-successful',
  imports: [
    RouterLink
  ],
  templateUrl: './checkout-successful.component.html',
  styleUrl: './checkout-successful.component.css'
})
export class CheckoutSuccessfulComponent {

}
